import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import PasswordForm from './PasswordForm';
import Button from '../components/Button';

const PasswordResetPage: React.FC = () => {
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token') || '';

    const handleSuccess = () => {
        setSuccess(true);
    };

    if (success) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-surface-tertiary p-4">
                <div className="bg-surface-inverse p-6 rounded-lg shadow-lg w-96">
                    <h2 className="pb-2 text-content-inverse text-lg font-medium">Password Reset Successfully</h2>
                    <p className="pb-4 text-content-inverse">You can now log in with your new password.</p>
                    <Button onClick={() => navigate('/login')}>Go to Login</Button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-surface-tertiary p-4">
            <PasswordForm token={token} isAuthenticated={false} onSuccess={handleSuccess} />
        </div>
    );
};

export default PasswordResetPage;
